import { ItineraryExpenses } from "./../itineray.model";
import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-itinerary-expenses-card",
  templateUrl: "./itinerary-expenses-card.component.html",
  styleUrls: ["./itinerary-expenses-card.component.css"]
})
export class ItineraryExpensesCardComponent implements OnInit {
  @Input()
  expenses: ItineraryExpenses;

  @Input()
  title: string;

  @Input()
  npax: number;

  constructor() { }

  ngOnInit() { }
}
